import { FeatureGroup, useFeatures } from 'utils/featuresContext';

const useFeature = (name: string): boolean | FeatureGroup => {
  const features = useFeatures();
  if (Array.isArray(features)) {
    return features.includes(name);
  }
  if (typeof features[name] === 'boolean') {
    return features[name];
  }

  return name.split('.').reduce<FeatureGroup | boolean>((featureGroup, featureName: string) => {
    if (typeof featureGroup === 'boolean') {
      return featureGroup;
    }
    if (featureGroup[featureName] === undefined) {
      return false;
    }

    return featureGroup[featureName];
  }, features);
};

export { useFeatures, useFeature };

export default useFeature;
